/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");
var jQuery = require("jquery");

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reduxPersist = require('redux-persist');

exports.default = _reduxPersist.persistStore; // flow



//////////////////
// WEBPACK FOOTER
// ./~/redux-offline/lib/defaults/persist.js
// module id = 1379
// module chunks = 60